import useUser from "hooks/useUser";
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "assets/logo.svg";
import { Container } from "@mui/material";

function Protected() {
  const { data, isLoading } = useUser();
  const { pathname } = useLocation();

  if (isLoading) {
    return (
      <Container
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#fff",
        }}>
        <Logo />
      </Container>
    );
  }

  if (!data)
    return (
      <Navigate
        to="/login"
        state={{
          from: pathname,
        }}
      />
    );
  return <Outlet />;
}

export default Protected;
